import QuinielazoService from "@/services/QuinielazoService";

export const namespaced = true;

export const state = {
    estadistica: []
};

export const mutations = {
    SET_ESTADISTICA(state, estadistica) {
        state.estadistica = estadistica;
    }
};

export const actions = {
    fetchEstadistica({ commit, dispatch }) {
        QuinielazoService.getEstadistica()
            .then(resp => {
                commit("SET_ESTADISTICA", resp.data);
            })
            .catch(err => {
                const notification = {
                    type: "error",
                    message: "Hubo un problema leyendo la estadistica"
                };
                dispatch("notification/add", notification, { root: true });
                return err;
            });
    }
};